<template>
  <div class="sb-tab" v-show="!hidden">
    <div :class="{ item: true, active: item.to === active }" v-for="item in items" :key="item.to">
      <router-link tag="button" class="link" :to="{ name: item.to }">{{ item.description }}</router-link>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    active: String,
    hidden: Boolean,
  },
  computed: {
    items() {
      return [
        {
          to: "characters",
          description: "登場人物",
        },
        {
          to: "worldViews",
          description: "世界観",
        },
      ];
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.sb-tab {
  height: 38px;
  width: 100%;
  display: flex;

  @include mq(sp) {
    flex-shrink: 0;
  }

  @include mq(pc) {
    display: none;
  }
}

.item {
  display: inline-block;
  flex-grow: 1;
  height: 100%;
  background-color: var(--color-surface-muted);
}

.item.active {
  background-color: var(--color-surface-subtle);
}

.link {
  width: 100%;
  height: 100%;
  text-align: center;
  margin: 0;
  background-color: transparent;
  border: solid 1px var(--color-border);
  color: var(--color-text-normal);
  font-weight: var(--font-weight-bold);
  transition: color 0.2s, background-color 0.2s;

  &:hover {
    color: var(--color-text-normal);
  }
}

.item.active .link {
  color: var(--color-text-normal);
  font-weight: var(--font-weight-bold);
}
</style>
